import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Statusbar } from '@/types/statusbar'

export function getStatusbar(): Promise<AxiosResponse<Statusbar>> {
  return instance.get(`/notification`)
}
